import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-36c61077"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "search-result"
};
const _hoisted_2 = {
  key: 0,
  class: "sketch-box"
};
const _hoisted_3 = {
  key: 1,
  class: "news-list news-left"
};
const _hoisted_4 = {
  class: "news-item-con"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["href", "name"];
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["href", "name"];
const _hoisted_9 = {
  key: 0,
  class: "taglist"
};
const _hoisted_10 = {
  class: "info"
};
const _hoisted_11 = {
  class: "date"
};
const _hoisted_12 = {
  class: "preview-count"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "t-icon t-icon-view"
}, null, -1));
const _hoisted_14 = {
  class: "like-count"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "t-icon t-icon-like"
}, null, -1));
const _hoisted_16 = {
  key: 0,
  class: "news-item-img"
};
const _hoisted_17 = ["name", "href"];
const _hoisted_18 = ["src", "alt"];
const _hoisted_19 = {
  key: 2,
  class: "news-left"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_t_result_hint = _resolveComponent("t-result-hint");
  const _component_t_news_skeleton = _resolveComponent("t-news-skeleton");
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_t_empty = _resolveComponent("t-empty");
  return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createVNode(_component_t_result_hint, {
    "search-word": _ctx.searchWord,
    "result-count": _ctx.total,
    "is-loading": _ctx.isLoading,
    onCancleSearch: _ctx.cancleSearch
  }, null, 8, ["search-word", "result-count", "is-loading", "onCancleSearch"]), [[_vShow, _ctx.searchWord]]), _createElementVNode("div", _hoisted_1, [_ctx.isLoading ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, count => {
    return _createElementVNode("li", {
      key: count + ''
    }, [_createVNode(_component_t_news_skeleton)]);
  }), 64))])) : _ctx.list.length ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
    var _item$tag, _item$tag2;
    return _openBlock(), _createElementBlock("li", {
      key: item.id,
      class: "news-item"
    }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("h4", {
      class: "title",
      onClick: $event => _ctx.newsClick(item, index)
    }, [_createElementVNode("a", {
      href: _ctx.handleUrl(`news/detail/${item.id}`),
      name: item.title,
      target: "_blank"
    }, _toDisplayString(item.title), 9, _hoisted_6)], 8, _hoisted_5), _createElementVNode("p", {
      class: "desc",
      onClick: $event => _ctx.newsClick(item, index)
    }, [_createElementVNode("a", {
      href: _ctx.handleUrl(`news/detail/${item.id}`),
      name: item.digest,
      target: "_blank"
    }, _toDisplayString(item.digest), 9, _hoisted_8)], 8, _hoisted_7), (_item$tag = item.tag) !== null && _item$tag !== void 0 && _item$tag.length ? (_openBlock(), _createElementBlock("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_item$tag2 = item.tag) === null || _item$tag2 === void 0 ? void 0 : _item$tag2.slice(0, 5), item => {
      return _openBlock(), _createBlock(_component_el_tag, {
        key: item,
        class: "mx-1",
        color: "#00a3fb",
        type: "info",
        onClick: $event => _ctx.handleTag(item)
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
        _: 2
      }, 1032, ["onClick"]);
    }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_10, [_createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.formatTimestamp(`${item.issue_at}`)), 1), _createElementVNode("span", _hoisted_12, [_hoisted_13, _createTextVNode(_toDisplayString(item.view), 1)]), _createElementVNode("span", _hoisted_14, [_hoisted_15, _createTextVNode(_toDisplayString(item.like), 1)])])]), item.general_image !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("a", {
      name: `资讯：${item.title}`,
      href: _ctx.handleUrl(`news/detail/${item.id}`),
      target: "_blank"
    }, [_createElementVNode("img", {
      src: item.general_image,
      alt: item.title
    }, null, 8, _hoisted_18)], 8, _hoisted_17)])) : _createCommentVNode("", true)]);
  }), 128))])) : !_ctx.isLoading ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createVNode(_component_t_empty, {
    title: "抱歉未找到您想要的信息"
  })])) : _createCommentVNode("", true)])], 64);
}